exports = module.exports = require("./../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CodeMirror-hints{position:absolute;z-index:10;overflow:hidden;list-style:none;margin:0;padding:2px;box-shadow:2px 3px 5px rgba(0,0,0,.2);border-radius:3px;border:1px solid silver;background:#fff;font-size:90%;font-family:monospace;max-height:20em;overflow-y:auto}.CodeMirror-hint{margin:0;padding:0 4px;border-radius:2px;white-space:pre;color:#000;cursor:pointer}li.CodeMirror-hint-active{background:#08f;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/codemirror/addon/hint/show-hint.css
// module id = 625
// module chunks = 0